<router-outlet></router-outlet> 
<ngx-spinner
  template="  "> 
    <div class="maincircle">

    <!-- <img src='/assets/DCI_Logo.gif' width='100px' height='100px'/> -->
  
  </div> 
</ngx-spinner> 
 


<!-- <ngx-spinner 
  template="<div class='box glowing'><img src='/assets/DCI Logo.gif' width='100px' height='100px'/></div>" ></ngx-spinner>  -->


<!-- <ngx-idle-timeout *ngIf="idleTimer"
  [allowedIdleTimeInSeconds]="1200" 
  [message]="'You Have Been Idle!'"
  [warningTimeInSeconds]="0"></ngx-idle-timeout> -->
  